<!-- Header Tabs -->
<mat-card>
  <mat-card-content>
    <div class="header-wrapper">
      <div class="mat-h2">{{ title }}</div>
      <div class="header-wrapper-right-button">
        <button
          mat-stroked-button
          color="primary"
          aria-label="refresh"
          mat-button
          (click)="recoverUserDialog()"
          [matTooltip]="'Recover_User' | translate"
        >
          <mat-icon>refresh</mat-icon>
          <span>{{ 'Recover_User' | translate }}</span>
        </button>
        <div
          [matTooltip]="
          this.selection.hasValue()
              ? ('Delete_Users' | translate)
              : ('Delete_User_Disabled' | translate)
          "
        >
          <button
            mat-stroked-button
            color="primary"
            aria-label="trash"
            mat-button
            (click)="userDelete()"
            [matTooltip]="'Delete_Users' | translate"
            [disabled]="!this.selection.hasValue()"
          >
            <mat-icon>delete_outline</mat-icon>
            <span>{{ 'Delete_Users' | translate }}</span>
          </button>
        </div>
        <mat-form-field floatLabel="always" appearance="outline" >
          <mat-label class="mat-label">{{
            'SEARCH.search' | translate
          }}</mat-label>
          <input
            id="search"
            #search
            matInput
            (keyup)="monitorSearch(search.value)"
            [placeholder]="'USERS_SEARCH.search_placeholder' | translate"
          />
          <mat-icon matSuffix>search</mat-icon>
        </mat-form-field>
      </div>
    </div>
    @if (noRecordFound && !_userServ.loading) {
      <app-not-found
        [displayMessage]="message"
      ></app-not-found>
    }

    <!-- table -->
    <table
      mat-table
      [dataSource]="usersDataSource"
      [ngClass]="noRecordFound ? 'hide' : ''"
      matSort
    >
      <ng-container matColumnDef="select">
        <th mat-header-cell *matHeaderCellDef>
          <mat-checkbox
            color="primary"
            (change)="$event ? masterToggle() : null"
            [checked]="selection.hasValue() && isAllSelected()"
            [indeterminate]="isPartiallySelected()"
            [disabled]="usersDataSource === undefined"
          >
          </mat-checkbox>
        </th>
        <td mat-header-cell class="border" mat-cell *matCellDef="let row">
          <mat-checkbox
            color="primary"
            (click)="$event.stopPropagation()"
            (change)="$event ? selection.toggle(row) : null"
            [checked]="selection.isSelected(row)"
          >
          </mat-checkbox>
        </td>
      </ng-container>
      <ng-container matColumnDef="name">
        <th mat-header-cell mat-sort-header *matHeaderCellDef width="40%">
          {{ 'LAST_USERS.name' | translate }}
        </th>
        <td (click)="handleRowClick(user)" mat-cell *matCellDef="let user" class="preserve-whitespace">
          {{ user.name }}
        </td>
      </ng-container>

      <ng-container matColumnDef="email">
        <th mat-header-cell *matHeaderCellDef>
          {{ 'LAST_USERS.email' | translate }}
        </th>
        <td (click)="handleRowClick(user)" mat-cell *matCellDef="let user">
          {{ user.email }}
        </td>
      </ng-container>

      <ng-container matColumnDef="lastLogin">
        <th mat-header-cell *matHeaderCellDef>
          {{ 'LAST_USERS.last_login' | translate }}
        </th>
        <td (click)="handleRowClick(user)" mat-cell *matCellDef="let user">
          {{ user.lastLogin }}
        </td>
      </ng-container>

      <ng-container matColumnDef="emailVerified">
        <th mat-header-cell *matHeaderCellDef>
          {{ 'LAST_USERS.email_verified' | translate }}
        </th>
        <td (click)="handleRowClick(user)" mat-cell *matCellDef="let user">
          @if (user.emailVerified) {
            <mat-icon class="check">check</mat-icon>
          }
          @if (!user.emailVerified) {
            <mat-icon class="close">close</mat-icon>
          }
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr
        mat-row
        *matRowDef="let row; columns: displayedColumns"
      ></tr>
    </table>
    @if (!noRecordFound) {
      <mat-paginator
        [showFirstLastButtons]="true"
        [pageSizeOptions]="[10, 25, 50, 100]"
      ></mat-paginator>
    }
  </mat-card-content>
</mat-card>
@if (_userServ.loading) {
  <app-spinner></app-spinner>
}
